<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder">
      <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title">
          Active Services
        </h3>
      </div>
    </div>

    <div class="kt-portlet__body kt-padding-t-0">
      <div class="table-responsive">
        <table id="kt_table_1" class="table table-striped- table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Service Name</th>
              <th>Token</th>
              <th>Request Count</th>
              <th>Error Count</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="isTableLoading">
              <td colspan="10" style="text-align: center">
                <LoadingSpinner />
              </td>
            </tr>
            <tr v-for="(service, idx) in activatedServices" v-else-if="activatedServices" :key="idx">
              <th scope="row">
                {{ idx + 1 }}
              </th>
              <td> {{ service.service }}</td>
              <td>
                <ul v-if="service.tokens" class="list-group list-group-flush">
                  <li v-for="(token, tokenIdx) in service.tokens" :key="tokenIdx" class="list-group-item">
                    {{ name[token.token] }}
                  </li>
                </ul>
                <div v-else>
                  None
                </div>
              </td>
              <td>
                <ul v-if="service.tokens" class="list-group list-group-flush">
                  <li v-for="(token, tokenIdx) in service.tokens" :key="tokenIdx" class="list-group-item">
                    {{ token.successCount | number }}
                  </li>
                </ul>
                <div v-else>
                  None
                </div>
              </td>
              <td>
                <ul v-if="service.tokens" class="list-group list-group-flush">
                  <li v-for="(token, tokenIdx) in service.tokens" :key="tokenIdx" class="list-group-item">
                    {{ token.errorCount | number }}
                  </li>
                </ul>
                <div v-else>
                  None
                </div>
              </td>
            </tr>
            <tr v-else>
              <td colspan="10" style="text-align: center">
                <div class="d-flex flex-column justify-content-center align-items-center kt-label-font-color-1" style="height: 250px">
                  <ListIcon />
                  <h5><span>No Data Available</span></h5>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from 'numeral'
import { mapActions } from 'vuex'
import ListIcon from '../components/ListIcon'
import LoadingSpinner from '../components/LoadingSpinner'
export default {
  filters: {
    number (value) {
      if (value) {
        return numeral(value).format('0,0')
      } else {
        return value
      }
    }
  },
  components: {
    ListIcon,
    LoadingSpinner
  },
  props: {
    range: Object
  },
  data () {
    return {
      isTableLoading: true,
      activatedServices: [],
      name: {}
    }
  },
  computed: {
    projectId () {
      return this.$route.params.projectId
    }
  },
  mounted () {
    this.getProjectService()
  },
  methods: {
    ...mapActions({
      getProjectServiceRequest: 'project/getProjectService',
      getSingleTokenDetailRequest: 'project/getSingleTokenDetail'
    }),
    async getProjectService () {
      const rangeOfErrorCount = this.range
      const responseData = await this.getProjectServiceRequest({
        projectId: this.projectId,
        start: rangeOfErrorCount.start,
        stop: rangeOfErrorCount.stop
      })
      await this.tokenName(responseData)
      this.activatedServices = responseData
      this.isTableLoading = false
    },
    async tokenName (resp) {
      for (const i in resp) {
        for (const j in resp[i].tokens) {
          const data = await this.getSingleTokenDetailRequest(resp[i].tokens[j].token)
          if (data.data && data.data.name) {
            this.name = {
              ...this.name,
              [resp[i].tokens[j].token]: data.data.name
            }
          }
        }
      }
    }
  }

}
</script>
